import { render, staticRenderFns } from "./PortfolioSingle.vue?vue&type=template&id=636332a5&scoped=true"
import script from "./PortfolioSingle.vue?vue&type=script&lang=js"
export * from "./PortfolioSingle.vue?vue&type=script&lang=js"
import style0 from "./PortfolioSingle.vue?vue&type=style&index=0&id=636332a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636332a5",
  null
  
)

export default component.exports